export const CLEAR_SUGGESTIONS = 'CLEAR_SUGGESTIONS';
export const MAYBE_UPDATE_SUGGESTIONS = 'MAYBE_UPDATE_SUGGESTIONS';

export const LOAD_SUGGESTIONS_BEGIN = 'LOAD_SUGGESTIONS_BEGIN';
export const LOAD_SUGGESTIONS_FAILED = 'LOAD_SUGGESTIONS_FAILED';
export const LOAD_SUGGESTIONS_SUCCEEDED = 'LOAD_SUGGESTIONS_SUCCEEDED';

export const FETCH_GUIDELINE_STARTED = 'FETCH_GUIDELINE_STARTED';
export const FETCH_GUIDELINE_SUCCEEDED = 'FETCH_GUIDELINE_SUCCEEDED';
export const FETCH_GUIDELINE_FAILED = 'FETCH_GUIDELINE_FAILED';

export const SAVE_INDEXING_STARTED = 'SAVE_INDEXING_STARTED';
export const SAVE_INDEXING_SUCCEEDED = 'SAVE_INDEXING_SUCCEEDED';
export const SAVE_INDEXING_FAILED = 'SAVE_INDEXING_FAILED';

export const FETCH_INDEXING_STARTED = 'FETCH_INDEXING_STARTED';
export const FETCH_INDEXING_SUCCEEDED = 'FETCH_INDEXING_SUCCEEDED';
export const FETCH_INDEXING_FAILED = 'FETCH_INDEXING_FAILED';

export const UPDATE_INPUT_ID = 'UPDATE_INPUT_ID';
export const UPDATE_STATUS_ID = 'UPDATE_STATUS_ID';
export const UPDATE_INPUT_TITLE = 'UPDATE_INPUT_TITLE';

export const FETCH_TERMS_STARTED = 'FETCH_TERMS_STARTED';
export const FETCH_TERMS_SUCCEEDED = 'FETCH_TERMS_SUCCEEDED';
export const FETCH_TERMS_FAILED = 'FETCH_TERMS_FAILED';
